if (process.env.DEPLOY_ENV === 'production') {
  module.exports = require('./configureStore.prod');
} else if (process.env.DEPLOY_ENV === 'release') {
  module.exports = require('./configureStore.release');
} else if (process.env.DEPLOY_ENV === 'staging') {
  module.exports = require('./configureStore.staging');
} else {
  module.exports = require('./configureStore.dev');
}
